
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { Post, PostList } from "@/lib/newExam/post";
import { BasicInformation } from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";

@Component({ components: {} })
export default class ExamInfo extends Vue {
  @Prop({ type: String, default: "edit" }) mode!: "edit" | "copy";
  @Prop({ type: BasicInformation, default: () => new BasicInformation() })
  param!: BasicInformation;
  @Prop({ type: Number, default: 0 }) isExamvd!: number;

  jobs: Post[] = [];
  formData = new BasicInformation();
  flattenJobs: number[] = [];
  get positionId() {
    return this.formData.positionId || undefined;
  }
  set positionId(v) {
    this.formData.positionId = v as number;
  }
  rules = {
    name: [{ required: true, message: "请输入面试名称", trigger: "change" }],
    positionId: [
      {
        validator: (rule: unknown, value: string, callback: Function) => {
          if (!value) {
            return callback(new Error("请选择岗位"));
          } else {
            callback();
          }
        },
        trigger: "change"
      }
    ]
  };

  visibleChange(flag: boolean) {
    console.log(flag);
    if (!flag) {
      // (this.$refs["form"] as any)?.validateField("positionId");
      // this.$nextTick(() => {
      //   this.onDataChange();
      // });
    } else if (
      !this.formData.positionId ||
      !this.flattenJobs.includes(this.formData.positionId)
    ) {
      // 没有选择时默认展开第一个岗位分类，可能会后台数据变更，加个保护
      const cascader = this.$refs.cascader as any;
      const panel = cascader?.$refs.panel;
      if (!panel) return;
      const node = panel.getNodeByValue([this.jobs[0].positionId]);
      panel.activePath = [node];
      panel.expandNodes([node]);
    }
  }

  // 获取岗位列表
  async getJobList() {
    const companyId = this.$route.query.companyId as string;
    const result = await PostList.get(companyId);
    this.jobs = result.positionGroups;
    this.flattenJobs = result.positions.map(item => item.positionId);
  }

  created() {
    this.formData = this.param;
    this.getJobList();
  }

  @Emit("close")
  editCancel() {
    return false;
  }

  @Emit("ok")
  editOk() {
    return new Promise(resolve => {
      (this.$refs["form"] as any)?.validate((valid: any) => {
        if (!valid) return;

        resolve(this.formData);
      });
    });
  }
}
